angular.module('admin.administrators.index', [
  'security.authorization',
  'services.utility',
  'services.adminResource'
]);

angular.module('admin.administrators.index').config(["$stateProvider", function($stateProvider) {
  $stateProvider
    .state('admin.administrators', {
      url: '/administrators',
      title: 'Manage Administrators',
      views: {
        'main@': {
          template: require('./admin-administrators.tpl.html'),
          controller: 'AdministratorsIndexCtrl',
          resolve: {
            administrators: ["adminResource", "$location", function(adminResource, $location) {
              return adminResource.findAdministrators($location.search());
            }]
          }
        }
      }
    });
}]);

angular.module('admin.administrators.index').controller('AdministratorsIndexCtrl', ['$scope', '$route', '$location', '$log', 'utility', 'adminResource', 'administrators',
  function($scope, $route, $location, $log, utility, adminResource, data){
    // local var
    var deserializeData = function(data){
      $scope.items = data.items;
      $scope.pages = data.pages;
      $scope.filters = data.filters;
      $scope.administrators = data.data;
    };

    var fetchAdministrators = function(){
      adminResource.findAdministrators($scope.filters).then(function(data){
        deserializeData(data);

        //update url in browser addr bar
        $location.search($scope.filters);
      }, function(e){
        $log.error(e);
      });
    };

    // $scope methods
    $scope.canSave = utility.canSave;
    $scope.filtersUpdated = function(){
      //reset pagination after filter(s) is updated
      $scope.filters.page = undefined;
      fetchAdministrators();
    };
    $scope.prev = function(){
      $scope.filters.page = $scope.pages.prev;
      fetchAdministrators();
    };
    $scope.next = function(){
      $scope.filters.page = $scope.pages.next;
      fetchAdministrators();
    };
    $scope.addAdmin = function(){
      adminResource.addAdministrator($scope.fullname).then(function(data){
        $scope.fullname = '';
        if(data.success){
          $route.reload();
        }else if (data.errors && data.errors.length > 0){
          alert(data.errors[0]);
        }else {
          alert('unknown error.');
        }
      }, function(e){
        $scope.fullname = '';
        $log.error(e);
      });
    };

    // $scope vars
    //select elements and their associating options
    $scope.sorts = [
      {label: "id \u25B2", value: "_id"},
      {label: "id \u25BC", value: "-_id"},
      {label: "name \u25B2", value: "name"},
      {label: "name \u25BC", value: "-name"}
    ];
    $scope.limits = [
      {label: "10 Materiałów", value: 10},
      {label: "20 Materiałów", value: 20},
      {label: "50 Materiałów", value: 50},
      {label: "100 Materiałów", value: 100}
    ];

    //initialize $scope variables
    deserializeData(data);
  }
]);



// WEBPACK FOOTER //
// ./client/src/app/admin/administrators/admin-administrators.js